import { Icon, VStack, Box, Text } from '@cad-arc';

export function NoServiceProviders() {
    return (
        <VStack w="full">
            <Box mt="8">
                <Icon size="lg" color="text.secondary" icon="Settings" />
            </Box>
            <Text variant="headingXs" color="text.secondary">
                No service providers to show
            </Text>
        </VStack>
    );
}
